import React, { useState } from 'react';
import { useQuery } from 'react-query';
import * as API from 'api';
import { Link } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import MuiTypography from '@material-ui/core/Typography';
import MuiPaper from '@material-ui/core/Paper';
import MuiGrid from '@material-ui/core/Grid';
import ViewWrapper from 'views/ViewWrapper';
import MuiButton from '@material-ui/core/Button';
import MuiTextField from '@material-ui/core/TextField';
import MuiInputAdornment from '@material-ui/core/InputAdornment';
import MuiSearchIcon from '@material-ui/icons/Search';
import MuiArrowUp from '@material-ui/icons/ArrowUpwardSharp';

import MuiTable from '@material-ui/core/Table';
import MuiTableBody from '@material-ui/core/TableBody';
import MuiTableCell from '@material-ui/core/TableCell';
import MuiTableContainer from '@material-ui/core/TableContainer';
import MuiTableRow from '@material-ui/core/TableRow';
import MuiTableHead from '@material-ui/core/TableHead';
import MuiCircularProgress from '@material-ui/core/CircularProgress';
import MuiTablePagination from '@material-ui/core/TablePagination';
import MuiTableFooter from '@material-ui/core/TableFooter';
import MuiBox from '@material-ui/core/Box';
import LabelRow from './ListComponents/LabelRow';
const styles = theme => ({
  paper: {
    overflow: 'hidden',
    padding: theme.spacing(2),
  },
  loadWrapper: {
    display: 'flex',
    justifyContent: 'center',
    margin: '1rem 0',
  },
  buttonStyle: {
    textDecoration: 'none',
  },
});

const Group = API.Groups();

function ListRecoupAccounts({ ...props }) {
  const [params, setParams] = useState({ page: 0, rowsPerPage: 250, order: 'asc' });

  const { data: groupsWithRecoup, isFetching } = useQuery(
    ['groupsWithRecoup', params?.page, params?.search, params?.rowsPerPage],
    () => {
      return Group.getAllWithRecoup(params);
    }
  );
  const { classes } = props;

  function handleFilter(value) {
    //This may want to debounce, but for now it searches on blur so it doesn't search in real time
    const newParams = { ...params, page: 0, search: value.toLowerCase() };
    if (!newParams.search) delete newParams.search;
    setParams(newParams);
  }

  function handleChangePage(_event, newPage) {
    setParams({ ...params, page: newPage });
  }

  function handleChangeRowsPerPage({ target: { value: newRowsPerPage } }) {
    setParams({ ...params, page: 0, rowsPerPage: newRowsPerPage });
  }

  return (
    <ViewWrapper>
      <MuiPaper className={classes.paper}>
        <MuiGrid container spacing={1}>
          <MuiGrid item xs={12}>
            <MuiTypography variant="h6">All label recoupment balances</MuiTypography>
          </MuiGrid>

          <MuiGrid item xs={9}>
            <MuiTextField
              variant="outlined"
              label="filter"
              placeholder="Filter by label name"
              onBlur={({ target: { value } }) => handleFilter(value)}
              InputProps={{
                startAdornment: (
                  <MuiInputAdornment position="start">
                    <MuiSearchIcon />
                  </MuiInputAdornment>
                ),
              }}
            />
          </MuiGrid>
          <MuiGrid item xs={3}>
            <Link className={classes.buttonStyle} to={'/recoupment-account/create'}>
              <MuiButton variant="contained">Create Recoupment Account</MuiButton>
            </Link>
          </MuiGrid>

          <MuiGrid item xs={12}>
            <MuiBox display="flex" justifyContent="flex-end">
              <MuiTablePagination
                rowsPerPageOptions={[250, 500, 1000]}
                rowsPerPage={params.rowsPerPage}
                count={groupsWithRecoup?.total || 0}
                page={params.page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </MuiBox>
          </MuiGrid>
        </MuiGrid>
        {isFetching || !groupsWithRecoup ? (
          <div className={classes.loadWrapper}>
            <MuiCircularProgress />
          </div>
        ) : (
          <MuiTableContainer>
            <MuiTable>
              <MuiTableHead>
                <MuiTableRow>
                  <MuiTableCell>
                    Label Name
                    <MuiArrowUp
                      style={{ cursor: 'pointer', transform: `${params.order === 'asc' ? 'scaleY(-1)' : 'scaleY(1)'}` }}
                      onClick={() =>
                        setParams(currentParams => ({
                          ...currentParams,
                          order: currentParams.order === 'asc' ? 'desc' : 'asc',
                        }))
                      }
                    />
                  </MuiTableCell>
                  <MuiTableCell align="right"></MuiTableCell>
                </MuiTableRow>
              </MuiTableHead>
              <MuiTableBody>
                {(groupsWithRecoup?.results || []).map((label, i) => (
                  <LabelRow label={label} key={i} />
                ))}
              </MuiTableBody>
              <MuiTableFooter>
                <MuiTableRow>
                  <MuiTableCell colSpan={2}>
                    <MuiBox display="flex" justifyContent="flex-end">
                      <MuiTablePagination
                        rowsPerPageOptions={[250, 500, 1000]}
                        rowsPerPage={params.rowsPerPage}
                        count={groupsWithRecoup?.total || 0}
                        page={params.page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                      />
                    </MuiBox>
                  </MuiTableCell>
                </MuiTableRow>
              </MuiTableFooter>
            </MuiTable>
          </MuiTableContainer>
        )}
      </MuiPaper>
    </ViewWrapper>
  );
}

export default withStyles(styles)(ListRecoupAccounts);
